import * as types from '../actions/types';

const initialState = {
    uniqueIdGenerationSearchdata:[],
    success: false
}

export default function UniqueIdGenerationReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_UNIQUE_ID_GENERATION_QUERY:
            return {
                uniqueIdGenerationSearchdata:action.payload,
                success: true
            } 
        default:
            return state
    }
}
